import React, { useState } from "react";
import { Modal, Button, Carousel } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import StarRating from './StarRating';

function Hotel({ hotel, fromDate, toDate }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const history = useHistory();

  return (
    <div className="row bs">
      <div className="col-md-4">
        <img src={hotel.imageurls[0]} className="smallimg" alt="" />
      </div>
      <div className="col-md-7">
        <h1>{hotel.name}</h1>
        <b>
          {/* <p>Max Count : {hotel.maxcount}</p>
          <p>Phone Number : {hotel.phonenumber}</p>
          <p>Type : {hotel.type}</p> */}
        <p>City: {hotel.city}</p>
        <p>Address: {hotel.address}</p>
        <StarRating rating={hotel.rating} />
        </b>

        <div style={{ float: "right" }}>
          {fromDate && toDate && (
            <Link to={`/book/${hotel._id}/${fromDate}/${toDate}`}>
              <button className="btn btn-primary m-2">Book Now</button>
            </Link>
          )}

          <button className="btn btn-primary" onClick={handleShow}>
            View Detail
          </button>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header>
          <Modal.Title>{hotel.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Carousel prevLabel="" nextLabel="">
            {hotel.imageurls.map((url,index) => {
              return (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100 h-100 bigimg"
                    src={url}
                    alt={`Slide ${index + 1}`}
                  />
                </Carousel.Item>
              );
            })}
          </Carousel>
        <p>Phone Number: {hotel.phonenumber}</p>
        <p>Address: {hotel.address}</p>
        <p>City: {hotel.city}</p>
        <p>Website: <a href={hotel.website} target="_blank" rel="noopener noreferrer">{hotel.website}</a></p>
        <p>Max Rooms: {hotel.maxcount}</p>
          <p>Email: {hotel.email}</p>
        <p>Description: {hotel.description}</p>
        </Modal.Body>
        <Modal.Footer>
        <Button type="primary" onClick={() => history.push(`/hotels/view/${hotel._id}`)}>
            View Rooms
        </Button>
        <Button type="primary" onClick={() => window.location.href="https://hotel-webgl-build.onrender.com"}>
            View Room in 3D
        </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Hotel;
